<mat-card appearance="outlined" class="dialog-card">
  <button class="close-btn" mat-icon-button (click)="onClose()" [attr.aria-label]="'common.close'|traduccion">
    <mat-icon>close</mat-icon>
  </button>

  <h2 mat-dialog-title>{{'myCommissions.shared.title'|traduccion}}</h2>

  <mat-dialog-content class="space-y-4">
    <section>
      <h3 class="text-base font-medium m-0">{{'myCommissions.shared.linkToShare'|traduccion}}</h3>
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>URL</mat-label>
        <input matInput [value]="commissionLink" readonly [attr.aria-label]="'commissions.shared.copyUrlLabel'|traduccion" />
        <button mat-icon-button matSuffix (click)="saveClipboard(commissionLink)" [attr.aria-label]="'commissions.shared.copyUrlClipboard'|traduccion" [attr.title]="'commissions.shared.copyUrl'|traduccion">
          <mat-icon>content_copy</mat-icon>
        </button>
        <mat-hint>{{'myCommissions.shared.copyManual'|traduccion}}</mat-hint>
      </mat-form-field>
    </section>

    <section>
      <h3 class="text-base font-medium m-0">{{'myCommissions.shared.discountCode'|traduccion}}</h3>

      @if (discountCodes.length) {
        <div class="discount-code-list">
          @for (discountCode of discountCodes; track discountCode) {
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>{{ discountCode.locationName || ('myCommissions.shared.location'|traduccion) }}</mat-label>
              <input
                matInput
                [value]="discountCode.code"
                readonly
                [attr.aria-label]="'commissions.shared.codeLabel'|traduccion:{location: discountCode.locationName}"
                />
                <button
                  mat-icon-button
                  matSuffix
                  (click)="saveClipboard(discountCode.code)"
                  [attr.aria-label]="'commissions.shared.copyCodeLabel'|traduccion:{location: discountCode.locationName}"
                  [attr.title]="'commissions.shared.copyCode'|traduccion"
                  >
                  <mat-icon>content_copy</mat-icon>
                </button>
                <mat-hint>{{'myCommissions.shared.location'|traduccion}}: {{ discountCode.locationName }}</mat-hint>
              </mat-form-field>
            }
          </div>
        } @else {
          <p class="empty-discount-codes">{{'myCommissions.shared.noDiscountCodes'|traduccion}}</p>
        }

      </section>
    </mat-dialog-content>
  </mat-card>
